import { Component, NgZone, OnInit } from '@angular/core';

import { AmplitudeService } from '@sondermind/amplitude';
import { Logger } from '@sondermind/datadog-logging';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})

export class AppComponent implements OnInit {
  constructor(
    private amplitudeService: AmplitudeService,
    private ngZone: NgZone,
    private logger: Logger
  ) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.amplitudeService.setupSessionReplay().catch((err: unknown) => {
        this.logger.error('Provider Landing: Amplitude session replay setup failed.', { err });
      });
    });
  }
}
